<style>
#techPreconditionsRegister .v--modal-box.v--modal {
  min-height: 350px !important;
  min-width: 600px !important;
}
#techPreconditionsRegister .modal__footer {
  display: none !important;
}
</style>

<template>
  <Modal
    modalName="techPreconditionsRegister"
    title="Rejestr warunków technicznych"
    :buttons="[]"
  >
    <TechnicalPreconditionsTable />
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";
import TechnicalPreconditionsTable from "../../table/investments/TechnicalPreconditionsTable.vue";

export default {
  components: {
    Modal,
    TechnicalPreconditionsTable
  },
  data: () => ({
  }),
  computed: {},
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/management/modals/TechnicalPreconditionsRegister.vue